<script setup lang="ts">
import { useRouter } from 'vue-router'
import { defineProps, computed } from 'vue'
import { PhoneIcon } from '@heroicons/vue/24/outline'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'

const router = useRouter()
const props = defineProps({
  phone: String,
  partnerId: Number,
  contactId: Number,
  disabled: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: Object,
    default: PhoneIcon,
  },
  variant: {
    type: String,
    default: 'default',
  },
  tooltipPosition: {
    type: String,
    default: 'top',
  },
})

function goToCallingPage(event: Event) {
  if (props.disabled) {
    event.preventDefault()
    return
  }
  const routeUrl = router.resolve({
    name: 'calling',
    params: {
      partnerId: props.partnerId,
    },
    query: {
      contactId: props.contactId,
    },
  }).href
  window.open(routeUrl, '_blank')
}

const className = computed(() =>
  !props.disabled ? 'tooltip tooltip-' + props.tooltipPosition : 'tooltip',
)
</script>

<template>
  <div :class="className" :data-tip="phone">
    <a @click="goToCallingPage" :href="'tel:' + phone">
      <ButtonDaisy text="" :icon="icon" :variant="variant" :disabled="disabled" />
    </a>
  </div>
</template>
